import PhotoSwipeLightbox from './photoswipe-lightbox.esm.js';

(function() {
  const lightbox = new PhotoSwipeLightbox({
    arrowPrevSVG: window.custom.icons.leftArrow,
    arrowNextSVG: window.custom.icons.rightArrow,
    closeSVG: window.custom.icons.close,
    zoom: false,
    counter: false,
    bgOpacity: 0.3,
    allowPanToNext: true,
    loop: true,
    pinchToClose: true,
    closeOnVerticalDrag: true,

    initialZoomLevel: (zoomLevelObject) => {
      if (isPhonePortrait()) {
        // return zoomLevelObject.fit;
        return zoomLevelObject.vFill;
      } else {
        return zoomLevelObject.fit;
      }
    },
    secondaryZoomLevel: (zoomLevelObject) => {
      if (isPhonePortrait()) {
        return 2;
      } else {
        return 1;
      }
    },
    // maxZoomLevel: (zoomLevelObject) => {
    //   if (isBigDesktop()) {
    //     return zoomLevelObject.fit;
    //   } else {
    //     return 2;
    //   }
    // },

    gallery: '.product-single__images-inside',
    children: 'a',
    pswpModule: () => import(window.modules.photoswipeEsm)
  });
  lightbox.on('uiRegister', function() {
    lightbox.pswp.ui.registerElement({
      name: 'custom-caption',
      order: 9,
      isButton: false,
      appendTo: 'root',
      html: '',
      onInit: (el, pswp) => {
        lightbox.pswp.on('change', () => {
          const captionEl = document.querySelector('[data-caption]');
          if (!captionEl) return;

          el.innerHTML = captionEl.dataset.caption || '';
        });
      }
    });
  });
  lightbox.init();
})();

function isPhonePortrait() {
  return window.matchMedia('(max-width: 750px) and (orientation: portrait)').matches;
}

// function isBigDesktop() {
//   return window.matchMedia('(min-width: 2000px)').matches;
// }